var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{staticClass:"agreement",attrs:{"id":_vm.id,"ok-title":"关闭","hide_cancel":"true","ok-disabled":!_vm.content,"size":"lg","scrollable":"true"},on:{"ok":_vm.agree}},[(_vm.content)?_c('div',{staticClass:"scrolling content",attrs:{"id":"content"},domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('Placeholder')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }